<template>
    <div
        class="min-h-full sm:bg-gray-100 flex sm:flex-col justify-center sm:py-12 sm:px-6 lg:px-8"
    >
        <div class="sm:mx-auto sm:w-full sm:max-w-xl">
            <div class="bg-white sm:shadow sm:rounded-lg px-4 py-5 sm:p-6">
                <form
                    v-if="!hasSubmitted"
                    @submit.prevent="store"
                    class="space-y-6"
                    action="#"
                    method="POST"
                >
                    <div class="grid grid-cols-12 gap-6">
                        <div class="col-span-12 lg:col-span-6">
                            <label
                                for="first_name"
                                class="block text-sm font-semibold text-gray-700"
                                >First name
                                <span class="text-red-500">*</span></label
                            >
                            <input
                                id="first_name"
                                type="text"
                                autocomplete="off"
                                name="first_name"
                                v-model="form.first_name"
                                class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                            />
                            <jet-input-error
                                :message="$page.props.errors.first_name"
                                class="mt-2"
                            />
                        </div>
                        <div class="col-span-12 lg:col-span-6">
                            <label
                                for="last_name"
                                class="block text-sm font-semibold text-gray-700"
                                >Last name
                                <span class="text-red-500">*</span></label
                            >
                            <input
                                id="last_name"
                                type="text"
                                autocomplete="off"
                                name="last_name"
                                required
                                v-model="form.last_name"
                                class="mt-1 px-3 py-2 focus:border-gray-400 focus:outline-none block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
                            />
                            <jet-input-error
                                :message="$page.props.errors.last_name"
                                class="mt-2"
                            />
                        </div>
                        <div class="col-span-12">
                            <label
                                for="phone_number"
                                class="block text-sm font-semibold text-gray-700"
                                >Phone
                                <span class="text-red-500">*</span></label
                            >
                            <maz-phone-number-input
                                id="phone-number"
                                v-model="form.phone_number"
                                :only-countries="['US']"
                                :required="true"
                                @update="phoneNumberUpdate"
                            />
                            <jet-input-error
                                :message="$page.props.errors.phone_number"
                                class="mt-2"
                            />
                        </div>
                        <div class="col-span-12">
                            <h2 class="font-medium">
                                Subscribing to receive SMS/MMS messages from {{webform.organization}}
                            </h2>
                        </div>
                        <div class="col-span-12">
                            <div class="relative flex items-start">
                                <div class="flex items-center h-5">
                                    <input
                                        id="terms"
                                        aria-describedby="terms-description"
                                        name="terms"
                                        v-model="form.terms"
                                        type="checkbox"
                                        class="h-4 w-4 border-gray-300 rounded"
                                    />
                                </div>
                                <div class="ml-3 text-sm">
                                    <label
                                        for="terms"
                                        class="font-medium text-gray-700"
                                        >Terms and conditions</label
                                    >
                                    <p
                                        id="terms-description"
                                        class="text-xs text-gray-500"
                                    >
                                        By providing a telephone number and submitting the form you are consenting to be contacted by SMS text message from {{ $page.props.webform.organization }}. Message frequency may vary. Message & data rates may apply. Reply STOP to opt out of further messaging. Reply HELP for more information. See our
                                        <a
                                            href="https://textspot.io/terms/"
                                            target="_blank"
                                            class="text-blue-500 underline cursor-pointer hover:text-blue-600   "
                                        >
                                            Terms of Service
                                        </a>
                                        and
                                        <a
                                            href="https://textspot.io/privacy-policy/"
                                            target="_blank"
                                            class="text-blue-500 underline cursor-pointer hover:text-blue-600   "
                                        >
                                            Privacy Policy
                                        </a>.
                                        See our
                                        <a
                                        href="https://textspot.io/terms/"
                                        target="_blank"
                                        class="text-blue-500 underline cursor-pointer hover:text-blue-600"
                                        >
                                            Terms of Service
                                        </a>.
                                    </p>
                                </div>
                            </div>
                            <jet-input-error
                                :message="$page.props.errors.terms"
                                class="mt-2"
                            />
                        </div>
                        <div class="col-span-12">
                            <button
                                type="submit"
                                class="inline-flex items-center justify-center w-full font-semibold px-3 py-3 border border-transparent leading-4 rounded-md shadow-sm text-white bg-orange-400 hover:bg-orange-500 focus:outline-none"
                            >
                                Subscribe now
                            </button>
                        </div>
                    </div>
                </form>
                <div v-else>
                    <div class="flex justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-14 w-14 text-green-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>
                    <p class="mt-6 text-lg text-medium text-center">
                        {{ webform.confirmation_text }}
                    </p>
                </div>
            </div>
            <div class="mt-6">
                <div class="text-sm text-center text-gray-600">
                    SMS marketing powered by
                    <a
                        href="https://textspot.io/?utm_source=iframe&utm_medium=web-form&utm_campaign=form"
                        target="_blank"
                        class="text-blue-500 underline hover:text-blue-600 cursor-pointer"
                        >
                        TextSpot
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    components: {
    },
    props: {
        webform: Object
    },
    data() {
        return {
            form: this.$inertia.form({
                uuid: this.webform.uuid,
                first_name: null,
                last_name: null,
                phone_number: null,
                terms: null
            }),
            hasSubmitted: false
        };
    },
    computed: {},
    mounted() {
        
    },
    methods: {
        store() {
            this.form.post(route("join.web-forms.store"), {
                onSuccess: () => {
                    this.hasSubmitted = true;
                }
            });
        }
    }
};
</script>
